import { useMainStore } from '@/store/main';
import currency from 'currency.js';
export const useCurrencyFormatter = () => {
    const store = useMainStore();
    function getCurrencySymbol(currencyCode) {
        return store.currencyDetails?.currency?.[currencyCode.toUpperCase()]?.symbol;
    }
    function formatCurrencyValue(val, currencyCode) {
        let symbol = store.currencySymbol;
        if (currencyCode) {
            symbol = getCurrencySymbol(currencyCode);
        }
        return currency(val).format({ decimal: '.', symbol });
    }
    function currencyValue(val) {
        return currency(val).format({
            decimal: '.',
            symbol: '',
        });
    }
    return {
        getCurrencySymbol,
        formatCurrencyValue,
        currencyValue,
    };
};
